// Dashboard Stats Constants
export const DASHBOARD_STATS_REQUEST = 'DASHBOARD_STATS_REQUEST';
export const DASHBOARD_STATS_SUCCESS = 'DASHBOARD_STATS_SUCCESS';
export const DASHBOARD_STATS_FAIL = 'DASHBOARD_STATS_FAIL';
export const DASHBOARD_STATS_RESET = 'DASHBOARD_STATS_RESET';

// Admin Dashboard Stats Constants
export const DASHBOARD_ADMIN_STATS_REQUEST = 'DASHBOARD_ADMIN_STATS_REQUEST';
export const DASHBOARD_ADMIN_STATS_SUCCESS = 'DASHBOARD_ADMIN_STATS_SUCCESS';
export const DASHBOARD_ADMIN_STATS_FAIL = 'DASHBOARD_ADMIN_STATS_FAIL';
export const DASHBOARD_ADMIN_STATS_RESET = 'DASHBOARD_ADMIN_STATS_RESET';

// Poker Tutorials Constants
export const DASHBOARD_TUTORIALS_REQUEST = 'DASHBOARD_TUTORIALS_REQUEST';
export const DASHBOARD_TUTORIALS_SUCCESS = 'DASHBOARD_TUTORIALS_SUCCESS';
export const DASHBOARD_TUTORIALS_FAIL = 'DASHBOARD_TUTORIALS_FAIL';

// Live Floor Status Constants
export const DASHBOARD_LIVE_FLOOR_REQUEST = 'DASHBOARD_LIVE_FLOOR_REQUEST';
export const DASHBOARD_LIVE_FLOOR_SUCCESS = 'DASHBOARD_LIVE_FLOOR_SUCCESS';
export const DASHBOARD_LIVE_FLOOR_FAIL = 'DASHBOARD_LIVE_FLOOR_FAIL';

// Active Sessions Constants
export const DASHBOARD_ACTIVE_SESSIONS_REQUEST = 'DASHBOARD_ACTIVE_SESSIONS_REQUEST';
export const DASHBOARD_ACTIVE_SESSIONS_SUCCESS = 'DASHBOARD_ACTIVE_SESSIONS_SUCCESS';
export const DASHBOARD_ACTIVE_SESSIONS_FAIL = 'DASHBOARD_ACTIVE_SESSIONS_FAIL';

// Dealer Status Constants
export const DASHBOARD_DEALER_STATUS_REQUEST = 'DASHBOARD_DEALER_STATUS_REQUEST';
export const DASHBOARD_DEALER_STATUS_SUCCESS = 'DASHBOARD_DEALER_STATUS_SUCCESS';
export const DASHBOARD_DEALER_STATUS_FAIL = 'DASHBOARD_DEALER_STATUS_FAIL';

// Dashboard Alerts Constants
export const DASHBOARD_ALERTS_REQUEST = 'DASHBOARD_ALERTS_REQUEST';
export const DASHBOARD_ALERTS_SUCCESS = 'DASHBOARD_ALERTS_SUCCESS';
export const DASHBOARD_ALERTS_FAIL = 'DASHBOARD_ALERTS_FAIL';

// Revenue Chart Constants
export const DASHBOARD_REVENUE_CHART_REQUEST = 'DASHBOARD_REVENUE_CHART_REQUEST';
export const DASHBOARD_REVENUE_CHART_SUCCESS = 'DASHBOARD_REVENUE_CHART_SUCCESS';
export const DASHBOARD_REVENUE_CHART_FAIL = 'DASHBOARD_REVENUE_CHART_FAIL';

// Player Growth Constants
export const DASHBOARD_PLAYER_GROWTH_REQUEST = 'DASHBOARD_PLAYER_GROWTH_REQUEST';
export const DASHBOARD_PLAYER_GROWTH_SUCCESS = 'DASHBOARD_PLAYER_GROWTH_SUCCESS';
export const DASHBOARD_PLAYER_GROWTH_FAIL = 'DASHBOARD_PLAYER_GROWTH_FAIL';

// Club Revenue Constants
export const DASHBOARD_CLUB_REVENUE_REQUEST = 'DASHBOARD_CLUB_REVENUE_REQUEST';
export const DASHBOARD_CLUB_REVENUE_SUCCESS = 'DASHBOARD_CLUB_REVENUE_SUCCESS';
export const DASHBOARD_CLUB_REVENUE_FAIL = 'DASHBOARD_CLUB_REVENUE_FAIL';

// Recent Transactions Constants
export const DASHBOARD_RECENT_TXN_REQUEST = 'DASHBOARD_RECENT_TXN_REQUEST';
export const DASHBOARD_RECENT_TXN_SUCCESS = 'DASHBOARD_RECENT_TXN_SUCCESS';
export const DASHBOARD_RECENT_TXN_FAIL = 'DASHBOARD_RECENT_TXN_FAIL';

// Pending Approvals Constants
export const DASHBOARD_PENDING_APPROVALS_REQUEST = 'DASHBOARD_PENDING_APPROVALS_REQUEST';
export const DASHBOARD_PENDING_APPROVALS_SUCCESS = 'DASHBOARD_PENDING_APPROVALS_SUCCESS';
export const DASHBOARD_PENDING_APPROVALS_FAIL = 'DASHBOARD_PENDING_APPROVALS_FAIL';

// Today's Highlights Constants
export const DASHBOARD_HIGHLIGHTS_REQUEST = 'DASHBOARD_HIGHLIGHTS_REQUEST';
export const DASHBOARD_HIGHLIGHTS_SUCCESS = 'DASHBOARD_HIGHLIGHTS_SUCCESS';
export const DASHBOARD_HIGHLIGHTS_FAIL = 'DASHBOARD_HIGHLIGHTS_FAIL';

